import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import {
  IoLogoFacebook,
  IoLogoTwitter,
  IoLogoInstagram,
  IoLogoLinkedin,
} from "react-icons/io";
import AboutWrapper from "./style";

const SocialLinks = [
  {
    icon: <IoLogoFacebook />,
    url: "https://www.facebook.com/redqinc/",
    tooltip: "Facebook",
  },
  {
    icon: <IoLogoInstagram />,
    url: "https://www.instagram.com/redqinc/",
    tooltip: "Instagram",
  },
  {
    icon: <IoLogoTwitter />,
    url: "https://twitter.com/redqinc",
    tooltip: "Twitter",
  },
  {
    icon: <IoLogoLinkedin />,
    url: "https://www.linkedin.com/company/redqinc/",
    tooltip: "Linked In",
  },
];

interface AboutProps {}

const About: React.FunctionComponent<AboutProps> = () => {
  const Data = useStaticQuery(graphql`
    query {
      avatar: file(absolutePath: { regex: "/about.jpg/" }) {
        childImageSharp {
          fluid(maxWidth: 1770, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      site {
        siteMetadata {
          author
          about
        }
      }
    }
  `);

  console.log("gg", Data.avatar.childImageSharp.fluid.src);
  return (
    <AboutWrapper>
      <div className="card-container">
        <span className="pro">🇹🇭 Thailand</span>
        <img
          alt="author"
          className="round"
          src={Data.avatar.childImageSharp.fluid.src}
        />
        <div className="bg-text">
          <h3>Mr.Sirawich Voungchuy</h3>
          <h3>[ -Front-End Developer- ]</h3>
        </div>
        <div className="skills">
          <h6>Skills</h6>
          <ul>
            <li>HTML</li>
            <li>CSS</li>
            <li>SSR Framework</li>
            <li>React</li>
            <li>Vue js</li>
            <li>Flutter</li>
            <li>React Native</li>
          </ul>
        </div>
      </div>
    </AboutWrapper>
  );
};

export default About;
